import Pageheader from 'components/Pageheader';
import React, { useEffect, useState, useContext } from 'react'
import { Helmet } from "react-helmet";
import { useNavigate, useSearchParams } from 'react-router-dom';
import ModalContext from 'contexts/ModalContext';
import { GetProfile, PostUpdateCustomer } from 'services/Api/Module/Customer';
import useProfileStore from 'services/store/ProfileModule';
import moment from 'moment';
import useTranslations from 'i18n/useTranslations';

const maxDate = moment().add(-16, "year").format("YYYY-MM-DD"); // 10 ปีที่แล้ว

const VerifiedForm = () => {
    const navigate = useNavigate();
    const { t, lang } = useTranslations();
    const { mAlert } = useContext(ModalContext);
    const [result, setResult] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);
    let [searchParams] = useSearchParams();
    const contactNumber = searchParams.get("contactNumber");
    const lineProfile = useProfileStore();
    const [isLoading, setIsLoading] = useState(true);
    const handleNext = (e) => {
        setIsFormValid(false)
        e.preventDefault();
        // console.log(result)
        let payload = {
            firstName: result?.firstName,
            lastName: result?.lastName,
            birthday: result?.birthday,
            gender: result?.gender,
            contactNumber: contactNumber || result?.contactNumber,
            email: result?.email,
            isConsentPdpa: result?.isConsentPdpa,
            isConsentMarketing: result?.isConsentMarketing,
            lineUid: lineProfile.profile.userId,
            lineName: lineProfile.profile.displayName,
            lineImgUrl: lineProfile.profile.pictureUrl
        }
        fetchUpdateCustomer(payload);
    }
    const handlePolicy = () => {
        if (lang == 'th') {
            navigate('/policy-th'+ window.location.search,{ state: { from: 'verify' } });
        } else {
            navigate('/policy-en'+ window.location.search,{ state: { from: 'verify' } });
        }
    }
    const handleBack = () => {
        navigate('/verified-Otp' + window.location.search)
    }
    const handleGenderChange = (e) => {
        setResult(prevResult => ({ ...prevResult, gender: e.target.value }));
    };
    const handleDateChange = (e) => {
        setResult({ ...result, birthday: e });
    };

    const calculateMaxDate = () => {
        const today = new Date();
        const maxDate = new Date();
        maxDate.setFullYear(today.getFullYear() - 16);
        return maxDate.toISOString().split('T')[0];
    };

    const fetchGetProfile = async (payload) => {
        try {
            const response = await GetProfile({ params: payload })
            const resData = response.data
            if (resData.resultCode == "20000") {
                setResult(resData.resultData[0]);
            } else {
                // setIsFail(true)
                mAlert.info({
                    title: "ไม่พบเบอร์มือถือ",
                    subTitle: "เบอร์มือถือนี้ไม่ตรงกับเบอร์ในระบบ",
                    content: "",
                    onClose: () => { },
                })
            }
        }
        catch (err) {
            console.log('err ', err)
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            })
        }
        setIsLoading(false)
    }
    const fetchUpdateCustomer = async (payload) => {
        try {
            const response = await PostUpdateCustomer({ data: payload })
            const resData = response.data
            if (resData.resultCode == "20000") {
                navigate('/verified-complete' + window.location.search, { state: { status: 0} });
            }else if(resData.resultCode == 40301){
                navigate('/verified-complete' + window.location.search, { state: { status: 1} });
            } else {
                mAlert.info({
                    title: "ไม่พบเบอร์มือถือ",
                    subTitle: "เบอร์มือถือนี้ไม่ตรงกับเบอร์ในระบบ",
                    content: "",
                    onClose: () => { },
                })
            }
        }
        catch (err) {
            console.log('err ', err)
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            })
        }
    }
    useEffect(() => {
        fetchGetProfile({ contactNumber });
    }, []);
    useEffect(() => {
        const isValid = result.firstName && result.lastName && result.birthday && result.gender !== undefined && result.contactNumber && result.email && result.isConsentPdpa == 1;
        setIsFormValid(isValid);
    }, [result]);
    const formatDateWithBuddhistYear = (date) => {
        const formattedDate = moment(date).locale('th').format('DD MMMM');
        const buddhistYear = parseInt(moment(date).format('YYYY')) + 543;
        return `${formattedDate} ${buddhistYear}`;
    };
    if (!isLoading) {
        return (
            <div>
                <Helmet>
                    <title>IMPACT Family</title>
                    <meta name="title" content="Impact Family" />
                    <meta name="description" content="Impact Family" />
                    <meta name="keyword" content="" />
                    <meta property="og:title" content="Impact Family" />
                    <meta property="og:description" content="Impact Family" />
                    <meta property="og:image" content="" />
                    <meta property="og:url" content="" />
                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content="Impact Family" />
                </Helmet>
                <div id="pageVerified-form">

                    <Pageheader pagename={t.register.verify} onClick={handleBack} />
                    <main id="top">
                        <div className="wrapContent">
                            <section id="pRegister">
                                <div className="bRegisterMain">
                                    <form>
                                        <div className="bForm">
                                            <div className="bGroup">
                                                <div className="bRow">
                                                    <div className="control-group validate">
                                                        <div className="inputPlaceholder">
                                                            <span>{t.register.firstName}</span>
                                                            <input type="text" name="text" placeholder={t.register.firstName} value={result.firstName || ''} onChange={(e) => setResult({ ...result, firstName: e.target.value })} />
                                                        </div>
                                                        <label htmlFor="" className="tError">Text Error Input</label>
                                                    </div>
                                                </div>
                                                <div className="bRow">
                                                    <div className="control-group validate">
                                                        <div className="inputPlaceholder">
                                                            <span>{t.register.lastName}</span>
                                                            <input type="text" name="text" placeholder={t.register.lastName} value={result.lastName || ''} onChange={(e) => setResult({ ...result, lastName: e.target.value })} />
                                                        </div>
                                                        <label htmlFor="" className="tError">Text Error Input</label>
                                                    </div>
                                                </div>
                                                <div className="bRow">
                                                    <div className="control-group">
                                                        <input type="text" name="text" value={result.contactNumber || contactNumber} disabled />
                                                        <label htmlFor="" className="tError">Text Error Input</label>
                                                    </div>
                                                </div>

                                                <div className="bRow">
                                                    <div className={`control-group validate ${!result.birthday ? "error" : ""}`}>
                                                        <div className="inputPlaceholder">
                                                            <span><i className="ico-cal"></i>{t.register.birthday}</span>
                                                            <input
                                                                placeholder="Date"
                                                                // type="text"
                                                                type="date"
                                                                className="inputDate"
                                                                // onFocus={(e) => e.target.type = 'date'}
                                                                // value={birthday ? moment(birthday).format('DD/MM/YYYY') : ""}
                                                                value={result.birthday ? moment(result.birthday).format('YYYY-MM-DD') : ""}
                                                                onChange={(e) => {
                                                                    console.log('e >>', e.target.value)
                                                                    const value = e.target.value

                                                                    if (!value) {
                                                                        mAlert.info({
                                                                            title: "แจ้งเตือน",
                                                                            subTitle: "กรุณากรอกข้อมูลวันเกิด",
                                                                            content: "",
                                                                            onClose: () => { },
                                                                        });
                                                                    } else if (moment(value).format("YYYY-MM-DD") > maxDate) {
                                                                        mAlert.info({
                                                                            title: "แจ้งเตือน",
                                                                            subTitle: "ผู้ลงทะเบียนต้องมีอายุไม่ต่ำกว่า 16 ปี",
                                                                            content: "",
                                                                            onClose: () => { },
                                                                        });
                                                                    } else {
                                                                        handleDateChange(value)
                                                                    }
                                                                }}
                                                                max={maxDate}
                                                            />
                                                        </div>
                                                        <label htmlFor="" className="tError">กรุณากรอกข้อมูลวันเกิด</label>
                                                    </div>
                                                </div>
                                                <div className="bRow">
                                                    <div className="control-group">
                                                        <div className="tTitle">{t.register.gender}</div>
                                                        <div className="gender">
                                                            <label className="control control--radio">{t.register.male}
                                                                <input type="radio" name="radio" value="0" checked={result.gender == "0"} onChange={handleGenderChange} />
                                                                <div className="control__indicator"></div>
                                                            </label>
                                                            <label className="control control--radio">{t.register.female}
                                                                <input type="radio" name="radio" value="1" checked={result.gender == "1"} onChange={handleGenderChange} />
                                                                <div className="control__indicator"></div>
                                                            </label>
                                                            <label className="control control--radio">{t.register.neutral}
                                                                <input type="radio" name="radio" value="2" checked={result.gender == "2"} onChange={handleGenderChange} />
                                                                <div className="control__indicator"></div>
                                                            </label>
                                                        </div>
                                                        <label htmlFor="" className="tError">Text Error Input</label>
                                                    </div>
                                                </div>
                                                <div className="bRow">
                                                    <div className="control-group validate">
                                                        <div className="inputPlaceholder">
                                                            <span>{t.register.email}</span>
                                                            <input type="text" name="text" placeholder={t.register.email} value={result.email || ''} onChange={(e) => setResult({ ...result, email: e.target.value })} />
                                                        </div>
                                                        <label htmlFor="" className="tError">Text Error Input</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="bPdpa">
                                                <div className="bRow">
                                                    <div className="control-group pdpa">
                                                        <label className="control control--checkbox">
                                                            <p>
                                                                {t.register.agree} <a onClick={handlePolicy}>{t.register.pdpa}</a>
                                                            </p>
                                                            <input type="checkbox" checked={result?.isConsentPdpa === 1} onChange={(e) => setResult({ ...result, isConsentPdpa: e.target.checked ? 1 : 0 })} />
                                                            <div className="control__indicator"></div>
                                                        </label>
                                                        <label htmlFor="" className="tError">จำเป็นต้องยินยอมรับข้อตกลงและเงื่อนไขและนโยบายความเป็นส่วนตัว</label>
                                                    </div>
                                                </div>
                                                <div className="bRow">
                                                    <div className="control-group pdpa">
                                                        <label className="control control--checkbox">
                                                            <p>
                                                                {t.register.agree} {t.register.marketing}<a href="policy-privacy.php"></a>
                                                            </p>
                                                            <input type="checkbox" checked={result?.isConsentMarketing === 1} onChange={(e) => setResult({ ...result, isConsentMarketing: e.target.checked ? 1 : 0 })} />
                                                            <div className="control__indicator"></div>
                                                        </label>
                                                        <label htmlFor="" className="tError">จำเป็นต้องยินยอมวัตถุประสงค์ทางการตลาด</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="bBtn">
                                                <button className="btn" onClick={handleNext} disabled={!isFormValid}>{t.register.next}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </section>
                        </div>
                    </main>

                </div>
            </div>
        )
    }
}

export default VerifiedForm